import { useAuth } from '../contexts/AuthContext';
import { Link } from 'react-router-dom';
import { Settings as SettingsIcon, LogOut, FileText, Users, Wrench } from 'lucide-react';

const Navbar = () => {
  const { user, logout } = useAuth();

  return (
    <nav className="bg-blue-900 text-white shadow-lg">
      <div className="container mx-auto px-3 md:px-4">
        <div className="flex justify-between items-center py-3 md:py-4">
          <Link to="/" className="flex items-center gap-2 md:gap-3">
            <div className="bg-white rounded-lg p-1.5 md:p-2">
              <SettingsIcon className="w-5 h-5 md:w-6 md:h-6 text-blue-900" />
            </div>
            <div className="hidden sm:block">
              <div className="text-lg md:text-xl font-bold">K.I.S. GmbH</div>
              <div className="text-xs text-blue-200">Klima • Installation • Service</div>
            </div>
            <div className="sm:hidden">
              <div className="text-base font-bold">K.I.S.</div>
            </div>
          </Link>
          
          {user && (
            <div className="flex items-center gap-2 md:gap-6">
              <Link
                to="/kunden"
                className="flex items-center gap-1 md:gap-2 text-blue-100 hover:text-white transition text-xs md:text-sm px-2 py-1.5 md:px-0"
              >
                <Users className="w-4 h-4" />
                <span className="hidden sm:inline">Kunden</span>
              </Link>
              <Link
                to="/anlagen"
                className="flex items-center gap-1 md:gap-2 text-blue-100 hover:text-white transition text-xs md:text-sm px-2 py-1.5 md:px-0"
              >
                <Wrench className="w-4 h-4" />
                <span className="hidden sm:inline">Anlagen</span>
              </Link>
              <Link
                to="/vorschriften"
                className="flex items-center gap-1 md:gap-2 text-blue-100 hover:text-white transition text-xs md:text-sm px-2 py-1.5 md:px-0 hidden md:flex"
              >
                <FileText className="w-4 h-4" />
                <span className="hidden sm:inline">Vorschriften</span>
              </Link>
              {user.role === 'admin' && (
                <>
                  <Link
                    to="/benutzer"
                    className="flex items-center gap-1 md:gap-2 text-blue-100 hover:text-white transition text-xs md:text-sm px-2 py-1.5 md:px-0"
                  >
                    <Users className="w-4 h-4" />
                    <span className="hidden sm:inline">Benutzer</span>
                  </Link>
                  <Link
                    to="/vorlagen-verwaltung"
                    className="flex items-center gap-1 md:gap-2 text-blue-100 hover:text-white transition text-xs md:text-sm px-2 py-1.5 md:px-0"
                  >
                    <FileText className="w-4 h-4" />
                    <span className="hidden sm:inline">Vorlagen</span>
                  </Link>
                </>
              )}
              <button
                onClick={logout}
                className="flex items-center gap-1 md:gap-2 text-blue-100 hover:text-white transition text-xs md:text-sm px-2 py-1.5 md:px-0"
                data-testid="logout-button"
              >
                <LogOut className="w-4 h-4" />
                <span className="hidden sm:inline">Abmelden</span>
              </button>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;